/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Line_Assignments_EmptyInputs */

const fr_line_assignments_empty = /** @type {(inputs: Line_Assignments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun véhicule n'a été observé sur cette ligne à cette date.`)
};

const en_line_assignments_empty = /** @type {(inputs: Line_Assignments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vehicle was observed on this line on this date.`)
};

/**
* | output |
* | --- |
* | "No vehicle was observed on this line on this date." |
*
* @param {Line_Assignments_EmptyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const line_assignments_empty = /** @type {((inputs?: Line_Assignments_EmptyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Line_Assignments_EmptyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_line_assignments_empty(inputs)
	return en_line_assignments_empty(inputs)
});